var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"300"}},[_c('v-card-text',{staticClass:"pa-2 caption black--text"},_vm._l((_vm.list),function(heatmap){return _c(heatmap.type,{key:heatmap.id,tag:"v-component",attrs:{"heatmap":heatmap,"map":_vm.map}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }